<template>
    <div
        v-if="
            state.currentView == 'GOOGLEPAY_INIT_VIEW' && state.processing != true
        "
    >
        <h5
            class="container__col-md-12 container__col-sm-12 payment__instruction"
        >
            {{ $t("googlepay.init.description") }}
        </h5>
        <PrimaryButton current-method="googlepay" :content="$t('googlepay.pay.btn')" @click="Next" />

    </div>
    <div
        v-else-if="
            state.currentView == 'REDIRECT_VIEW' && state.processing != true
        "
    >
        <div class="redirect-wrapper">
            <img
                class="redirect-icon--google-pay"
                :src="require('@/assets/icons/google-pay-logo-lg.svg')"
                alt="redirect-icon"
            />
        </div>
        <p class="container__col-md-12 container__col-sm-12 payment__instruction--google-pay">
            {{ $t("googlepay.redirect.description")}}
        </p>
        <PrimaryButton current-method="googlepay" :content="$t('googlepay.redirect.btn')" @click="Next" />
    </div>
</template>

<script>
import { ref, onBeforeUnmount } from "vue";
import { injectStore, mapState } from "redux-vuex";

import { getValueFromPath, autoInitialize } from "@/support/helpers";
import PrimaryButton from "@/components/form/base-button";
import { onUpdated } from "@vue/runtime-core";

export default {
    name: "Googlepay",
    components: {
        PrimaryButton,
    },

    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());

        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        const autoInitializePayment = autoInitialize("GOOGLEPAY_INIT_VIEW");

        onUpdated(() =>  autoInitializePayment(checkoutData, Next));

        onBeforeUnmount(() => {
            subscription();
        });

        return {
            state: mapState({
                processing: (state) => getValueFromPath(state, "processing") || false,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
            }),
            getValueFromPath,
            Next,
        };

    },

};
</script>

<style>

</style>